import React, { Fragment } from 'react';
import className from 'classnames';
import { bool, func, string } from 'prop-types';

const BooleanInput = ({
  param,
  value,
  updateHandler = () => {}
}) => {
  const onHandler = value ? null : () => updateHandler(param, true)
  const offHandler = value ? () => updateHandler(param, false) : null
  return (
    <Fragment>
      <button type='button' className='Button Button--transparent' onClick={onHandler}>
        <span className={`Badge Badge--block ${className({'Badge--gray-light': !value})}`}>
          ON
        </span>
      </button>
      <button type='button' className='Button Button--transparent' onClick={offHandler}>
        <span className={`Badge Badge--block ${className({'Badge--gray-light': value, 'Badge--red': !value})}`}>
          OFF
        </span>
      </button>
    </Fragment>
  )
}

BooleanInput.propTypes = {
  param: string.isRequired,
  value: bool.isRequired,
  updateHandler: func.isRequired
}

export default BooleanInput